function no(I) {
  return I && I.__esModule && Object.prototype.hasOwnProperty.call(I, "default") ? I.default : I;
}
var gr, ro = { exports: {} };
gr = () => (() => {
  var I = { d: (e, t) => {
    for (var n in t) I.o(t, n) && !I.o(e, n) && Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
  }, o: (e, t) => Object.prototype.hasOwnProperty.call(e, t) }, $ = {};
  function F(e) {
    return F = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, F(e);
  }
  function re(e) {
    var t = function(n, r) {
      if (F(n) != "object" || !n) return n;
      var o = n[Symbol.toPrimitive];
      if (o !== void 0) {
        var i = o.call(n, r);
        if (F(i) != "object") return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (r === "string" ? String : Number)(n);
    }(e, "string");
    return F(t) == "symbol" ? t : t + "";
  }
  function y(e, t, n) {
    return (t = re(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
  }
  function Qt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function(o) {
        return Object.getOwnPropertyDescriptor(e, o).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function m(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Qt(Object(n), !0).forEach(function(r) {
        y(e, r, n[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qt(Object(n)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
      });
    }
    return e;
  }
  function vr(e, t) {
    if (e == null) return {};
    var n, r, o = function(a, u) {
      if (a == null) return {};
      var c, s, l = {}, g = Object.keys(a);
      for (s = 0; s < g.length; s++) c = g[s], u.indexOf(c) >= 0 || (l[c] = a[c]);
      return l;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
    }
    return o;
  }
  I.d($, { default: () => or });
  var ft = 1e3, Xt = 36e5, Zt = 24 * Xt, W = function(e) {
    return e.REASON_GENERAL = "general", e.REASON_GDPR = "gdpr", e;
  }({}), mt = { TRANSACTION_ERROR: "XHR transaction failed due to an error", SERVER_MALFORMED_RESPONSE: "Response from server is malformed", SERVER_INTERNAL_ERROR: "Internal error occurred on the server", SERVER_CANNOT_PROCESS: "Server was not able to process the request, probably due to error coming from the client", NO_CONNECTION: "No internet connectivity", SKIP: "Skipping slower attempt", MISSING_URL: "Url is not provided" }, ve = function(e) {
    return e.NO_STORAGE = "noStorage", e.INDEXED_DB = "indexedDB", e.LOCAL_STORAGE = "localStorage", e;
  }({}), hr = { default: "adjust.com", india: "adjust.net.in", china: "adjust.world", world: "adjust.world", EU: "eu.adjust.com", TR: "tr.adjust.com", US: "us.adjust.com" }, $t = "https://", en = "activity:web_uuid", tn = "activity:attribution";
  function gt(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r;
  }
  function pt(e, t) {
    if (e) {
      if (typeof e == "string") return gt(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? gt(e, t) : void 0;
    }
  }
  function k(e, t) {
    return function(n) {
      if (Array.isArray(n)) return n;
    }(e) || function(n, r) {
      var o = n == null ? null : typeof Symbol != "undefined" && n[Symbol.iterator] || n["@@iterator"];
      if (o != null) {
        var i, a, u, c, s = [], l = !0, g = !1;
        try {
          if (u = (o = o.call(n)).next, r === 0) {
            if (Object(o) !== o) return;
            l = !1;
          } else for (; !(l = (i = u.call(o)).done) && (s.push(i.value), s.length !== r); l = !0) ;
        } catch (f) {
          g = !0, a = f;
        } finally {
          try {
            if (!l && o.return != null && (c = o.return(), Object(c) !== c)) return;
          } finally {
            if (g) throw a;
          }
        }
        return s;
      }
    }(e, t) || pt(e, t) || function() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }();
  }
  function ee(e) {
    return !Object.keys(e).length && e.constructor === Object;
  }
  function he(e) {
    return F(e) === "object" && e !== null && !(e instanceof Array);
  }
  function nn(e) {
    try {
      return he(JSON.parse(e));
    } catch (t) {
      return !1;
    }
  }
  function rn(e, t, n) {
    function r(i) {
      return Array.isArray(t) ? t.every(function(a) {
        return i[a] === n[a];
      }) : i[t] === n;
    }
    for (var o = 0; o < e.length; o += 1) if (r(e[o])) return o;
    return -1;
  }
  function ue() {
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).reduce(function(e, t) {
      return m(m({}, e), {}, y({}, t.key, t.value));
    }, {});
  }
  function on() {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).filter(function(t) {
      return e.indexOf(t) !== -1;
    });
  }
  function oe(e, t) {
    return new RegExp("\\/".concat(t, "(\\/.*|\\?.*){0,1}$")).test(e);
  }
  function R(e, t) {
    var n = k(t, 2), r = n[0], o = n[1];
    return m(m({}, e), {}, y({}, r, o));
  }
  function x(e) {
    return Object.keys(e).map(function(t) {
      return [t, e[t]];
    });
  }
  function Ne(e) {
    return Object.keys(e).map(function(t) {
      return e[t];
    });
  }
  function vt(e) {
    return he(e) ? !ee(e) : !!e || e === 0;
  }
  function an() {
    try {
      var e = (/* @__PURE__ */ new Date()).toString(), t = window.localStorage;
      t.setItem(e, e);
      var n = t.getItem(e) === e;
      return t.removeItem(e), !(!n || !t);
    } catch (r) {
      return !1;
    }
  }
  const se = { namespace: "adjust-sdk", version: "5.7.2", env: "production" };
  var ht = "error", un = "warning", sn = "info", qe = "verbose", yt = y(y(y(y(y({}, "none", -1), ht, 0), un, 1), sn, 2), qe, 3), yr = { log: "  ", info: " ", warn: " ", error: "" }, br = { development: qe, production: ht, test: qe }, bt = cn(), Ge = "";
  function cn() {
    return br[se.env];
  }
  function kt(e, t) {
    var n;
    if (!(yt[bt] < yt[t])) {
      for (var r = (/* @__PURE__ */ new Date()).toISOString(), o = yr[e], i = ["[".concat(se.namespace, "]"), r, "".concat(e.toUpperCase(), ":").concat(o)], a = Ge ? document.querySelector(Ge) : null, u = arguments.length, c = new Array(u > 2 ? u - 2 : 0), s = 2; s < u; s++) c[s - 2] = arguments[s];
      (n = console)[e].apply(n, i.concat(c)), a && (a.textContent += "".concat(i.join(" "), " ").concat(c.map(function(l) {
        return he(l) ? JSON.stringify(l) : l;
      }).join(" "), `
`), a.scrollTop = a.scrollHeight);
    }
  }
  function Me(e, t) {
    return function() {
      for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
      kt.apply(void 0, [e, t].concat(r));
    };
  }
  const d = { setLogLevel: function(e, t) {
    e && Object.keys(yt).indexOf(e) === -1 ? kt("error", "error", "You must set one of the available log levels: verbose, info, warning, error or none") : (bt = e || cn(), Ge = t || Ge, kt("info", e, "Log level set to ".concat(bt)));
  }, log: Me("log", qe), info: Me("info", sn), warn: Me("warn", un), error: Me("error", ht) };
  var ye = null, Fe = null, St = ["appToken", "environment"], kr = [].concat(St, ["defaultTracker", "externalDeviceId"]), Sr = ["customUrl", "dataResidency", "urlStrategy", "eventDeduplicationListLimit", "namespace"];
  function ln(e) {
    var t = St.filter(function(n) {
      return !e[n];
    });
    return !!t.length && (d.error("You must define ".concat(function(n) {
      if (!n.length) return "";
      if (n.length === 1) return "".concat(n[0]);
      var r = n.length - 1, o = n.slice(0, r).join(", ");
      return "".concat(o, " and ").concat(n[r]);
    }(t))), !0);
  }
  const _ = { sessionWindow: 18e5, sessionTimerWindow: 6e4, requestValidityWindow: 28 * Zt, set: function(e) {
    ln(e) || (ye = kr.filter(function(t) {
      return !!e[t];
    }).map(function(t) {
      return [t, e[t]];
    }).reduce(function(t, n) {
      return R(t, n);
    }, {}), Fe = Sr.filter(function(t) {
      return !!e[t];
    }).map(function(t) {
      return [t, e[t]];
    }).reduce(R, {}));
  }, getBaseParams: function() {
    return ye ? m({}, ye) : {};
  }, getCustomConfig: function() {
    return Fe ? m({}, Fe) : {};
  }, isInitialised: function() {
    return St.reduce(function(e, t) {
      return e && !!ye && !!ye[t];
    }, !0);
  }, hasMissing: ln, destroy: function() {
    ye = null, Fe = null;
  } };
  var dn = function(e) {
    return e.Queue = "queue", e.ActivityState = "activityState", e.GlobalParams = "globalParams", e.EventDeduplication = "eventDeduplication", e;
  }(dn || {}), ce = function(e) {
    return e.Queue = "q", e.ActivityState = "as", e.GlobalParams = "gp", e.EventDeduplication = "ed", e;
  }(ce || {}), Oe = function(e) {
    return e.Preferences = "p", e;
  }(Oe || {}), wr = { fields: { thirdPartySharingDisabled: { key: "td", keys: { reason: { key: "r", values: y({}, W.REASON_GENERAL, 1) }, pending: { key: "p", values: { false: 0, true: 1 } } } }, sdkDisabled: { key: "sd", keys: { reason: { key: "r", values: y(y({}, W.REASON_GENERAL, 1), W.REASON_GDPR, 2) }, pending: { key: "p", values: { false: 0, true: 1 } } } } } };
  function We(e) {
    return !!e && Object.prototype.hasOwnProperty.call(e, "values");
  }
  function fn(e) {
    return !!e && Object.prototype.hasOwnProperty.call(e, "keys");
  }
  function Ve(e) {
    return !!e && Object.prototype.hasOwnProperty.call(e, "composite");
  }
  function wt(e) {
    return !!e && typeof e != "string";
  }
  const Ie = { queue: { name: ce.Queue, scheme: { keyPath: "timestamp", autoIncrement: !1, fields: { url: { key: "u", values: { "/session": 1, "/event": 2, "/gdpr_forget_device": 3, "/sdk_click": 4, "/disable_third_party_sharing": 5 } }, method: { key: "m", values: { GET: 1, POST: 2, PUT: 3, DELETE: 4 } }, timestamp: "t", createdAt: "ca", params: { key: "p", keys: { timeSpent: "ts", sessionLength: "sl", sessionCount: "sc", eventCount: "ec", lastInterval: "li", eventToken: "et", revenue: "re", currency: "cu", callbackParams: "cp", partnerParams: "pp" } } } } }, activityState: { name: ce.ActivityState, scheme: { keyPath: "uuid", autoIncrement: !1, fields: { uuid: { key: "u", values: { unknown: "-" } }, timeSpent: "ts", sessionLength: "sl", sessionCount: "sc", eventCount: "ec", lastActive: "la", lastInterval: "li", installed: { key: "in", values: { false: 0, true: 1 } }, attribution: { key: "at", keys: { adid: "a", tracker_token: "tt", tracker_name: "tn", network: "nt", campaign: "cm", adgroup: "ag", creative: "cr", click_label: "cl", state: { key: "st", values: { installed: 1, reattributed: 2 } } } } } } }, globalParams: { name: ce.GlobalParams, scheme: { keyPath: "keyType", autoIncrement: !1, index: "type", fields: { keyType: { key: "kt", composite: ["key", "type"] }, key: "k", value: "v", type: { key: "t", values: { callback: 1, partner: 2 } } } } }, eventDeduplication: { name: ce.EventDeduplication, scheme: { keyPath: "internalId", autoIncrement: !0, fields: { internalId: "ii", id: "i" } } }, preferences: { name: Oe.Preferences, scheme: wr, permanent: !0 } };
  function Pr(e) {
    try {
      return JSON.parse(e);
    } catch (t) {
      return e;
    }
  }
  function Dr(e, t, n) {
    var r, o = We(n) ? { values: (r = n.values, x(r).map(function(u) {
      var c = k(u, 2), s = c[0];
      return [c[1], Pr(s)];
    }).reduce(R, {})) } : {}, i = fn(n) ? { keys: mn(e, n.keys) } : {}, a = Ve(n) ? { composite: n.composite.map(function(u) {
      return Pt(e, u);
    }) } : {};
    return m(m(m({ key: t }, o), i), a);
  }
  function mn(e, t) {
    return x(t).map(function(n) {
      var r = k(n, 2), o = r[0], i = r[1];
      return wt(i) ? [i.key, Dr(e, o, i)] : [i, o];
    }).reduce(R, {});
  }
  function Pt(e, t) {
    if (t) {
      var n = Ie[e].scheme.fields[t];
      return wt(n) ? n.key : n || t;
    }
  }
  var gn = x(Ie).map(function(e) {
    var t = k(e, 2), n = t[0], r = t[1];
    return [n, { keyPath: r.scheme.keyPath, autoIncrement: r.scheme.autoIncrement, index: r.scheme.index, fields: r.scheme.fields }];
  }).reduce(R, {}), Nr = x(gn).map(function(e) {
    var t = k(e, 2), n = t[0], r = t[1];
    return [n, { keyPath: Pt(n, r.keyPath), autoIncrement: r.autoIncrement, index: Pt(n, r.index), fields: mn(n, r.fields) }];
  }).reduce(R, {}), Or = x(Ie).reduce(function(e, t) {
    var n = k(t, 2)[1];
    return e.concat(n.scheme.fields);
  }, []).map(function(e) {
    return Ne(e).filter(We).map(function(t) {
      return x(t.values);
    }).reduce(function(t, n) {
      return t.concat(n);
    }, []);
  }).reduce(function(e, t) {
    return e.concat(t);
  }, []).reduce(R, {}), pn = x(Ie).map(function(e) {
    var t = k(e, 2), n = t[0], r = t[1];
    return [n, { name: r.name, permanent: r.permanent }];
  }).reduce(R, {});
  const E = { left: gn, right: Nr, values: Or, storeNames: { left: pn, right: (vn = pn, x(vn).map(function(e) {
    var t = k(e, 2), n = t[0], r = t[1], o = { name: n, permanent: r.permanent };
    return [r.name, o];
  }).reduce(R, {})) } };
  var vn, xe = function(e) {
    return e.LowerBound = "lowerBound", e.UpperBound = "upperBound", e;
  }(xe || {});
  function hn(e) {
    return he(e);
  }
  var S = function(e) {
    return e.right = "right", e.left = "left", e;
  }(S || {});
  function yn(e, t) {
    return e && e[t] !== void 0 ? e[t] : t;
  }
  function Q(e, t, n, r) {
    if (n) {
      var o = r || E[t][V(e, S.right)].fields;
      return x(n).map(function(i) {
        var a = k(i, 2), u = a[0], c = a[1];
        return function(s, l, g, f, p) {
          if (!p) return [g, f];
          var v = wt(p) ? p.key : p;
          return hn(f) ? [v, Q(s, l, f, fn(p) ? p.keys : null)] : [v, yn(We(p) ? p.values : null, f)];
        }(e, t, u, c, o[u]);
      }).reduce(function(i, a) {
        var u = k(a, 2), c = u[0], s = u[1];
        return m(m({}, i), {}, y({}, c, s));
      }, {});
    }
  }
  function Dt(e, t) {
    return (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : []).map(function(n) {
      return Q(e, t, n);
    });
  }
  function le(e, t, n) {
    var r = E[t][V(e, S.right)], o = r.fields[r.keyPath], i = n instanceof Array ? n.slice() : [n], a = (Ve(o) ? o.composite : [r.keyPath]).map(function(u, c) {
      var s = r.fields[u];
      return yn(We(s) ? s.values : null, i[c]);
    });
    return a.length === 1 ? a[0] : a;
  }
  function bn(e) {
    return E.values[e] || e;
  }
  function V(e, t) {
    return (E.storeNames[t][e] || {}).name || e;
  }
  function Nt(e, t) {
    return { name: t.name, message: t.message.replace('"'.concat(e, '"'), V(e, S.right)) };
  }
  function Ae(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function kn(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, re(r.key), r);
    }
  }
  function Re(e, t, n) {
    return t && kn(e.prototype, t), n && kn(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function ie(e) {
    for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, n = e + "", r = 1; r <= t; r += 1) e < Math.pow(10, r) && (n = "0".concat(n));
    return n;
  }
  function Ee(e) {
    var t = e ? new Date(e) : /* @__PURE__ */ new Date(), n = function(i) {
      var a = ie(i.getDate()), u = ie(i.getMonth() + 1);
      return [i.getFullYear(), u, a].join("-");
    }(t), r = function(i) {
      var a = ie(i.getHours(), 1), u = ie(i.getMinutes()), c = ie(i.getSeconds()), s = ie(i.getMilliseconds(), 2);
      return [a, u, c].join(":") + "." + s;
    }(t), o = function(i) {
      var a = i.getTimezoneOffset();
      return (a > 0 ? "-" : "+") + ie(Math.floor(Math.abs(a) / 60)) + ie(Math.abs(a) % 60);
    }(t);
    return "".concat(n, "T").concat(r, "Z").concat(o);
  }
  function Ot(e, t) {
    return isNaN(e) || isNaN(t) ? 0 : Math.abs(t - e);
  }
  var de = {}, It = [];
  function ae(e, t) {
    var n = "id" + Math.random().toString(36).substring(2, 16), r = { id: n, cb: t };
    return de[e] || (de[e] = []), de[e].push(r), n;
  }
  function H(e, t) {
    de[e] && de[e].forEach(function(n) {
      typeof n.cb == "function" && It.push(setTimeout(function() {
        return n.cb(e, t);
      }));
    });
  }
  var P = {}, T = !1, be = !1;
  function Sn() {
    P = T ? m({}, arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}) : {};
  }
  function He() {
    var e;
    T && (P.lastInterval = (e = P.lastActive) ? Math.round(Ot(e, Date.now()) / ft) : -1, P.lastActive = Date.now());
  }
  function je(e) {
    P = m(m({}, P), e);
  }
  function wn() {
    be = !0;
  }
  function Pn() {
    var e = P.lastActive;
    return Math.round(Ot(e, Date.now()) / ft);
  }
  function Dn() {
    return (P.timeSpent || 0) + (be ? Pn() : 0);
  }
  function xt() {
    var e = Ot(P.lastActive, Date.now()) < _.sessionWindow, t = be || !be && e;
    return (P.sessionLength || 0) + (t ? Pn() : 0);
  }
  function Nn() {
    T && (je({ timeSpent: Dn(), sessionLength: xt() }), He());
  }
  const h = { get current() {
    return T ? m({}, P) : {};
  }, set current(e) {
    Sn(e);
  }, init: function(e) {
    T = !0, Sn(e);
  }, isStarted: function() {
    return T;
  }, toForeground: wn, toBackground: function() {
    be = !1;
  }, initParams: function() {
    Nn(), wn();
  }, getParams: function(e) {
    if (!T) return null;
    var t = P.lastInterval >= 0 ? P.lastInterval : 0, n = { timeSpent: P.timeSpent || 0, sessionLength: P.sessionLength || 0, sessionCount: P.sessionCount || 1, lastInterval: t || 0 };
    return e && oe(e, "event") && (n.eventCount = P.eventCount), n;
  }, updateParams: function(e, t) {
    if (T) {
      var n = {};
      n.timeSpent = Dn(), n.sessionLength = xt(), oe(e, "session") && (n.sessionCount = (P.sessionCount || 0) + 1), oe(e, "event") && (n.eventCount = (P.eventCount || 0) + 1), je(n), t || He();
    }
  }, updateInstalled: function() {
    T && (P.installed || je({ installed: !0 }));
  }, updateSessionOffset: Nn, updateSessionLength: function() {
    T && (je({ sessionLength: xt() }), He());
  }, resetSessionOffset: function() {
    T && je({ timeSpent: 0, sessionLength: 0 });
  }, updateLastActive: He, destroy: function() {
    P = {}, T = !1, be = !1;
  }, getAttribution: function() {
    return T ? P.attribution ? P.attribution : (d.log("No attribution data yet"), null) : null;
  }, getWebUUID: function() {
    return T ? P.uuid : null;
  }, waitForAttribution: function() {
    return P.attribution ? Promise.resolve(P.attribution) : new Promise(function(e) {
      return ae(tn, function(t, n) {
        return e(n);
      });
    });
  }, waitForWebUUID: function() {
    return P.uuid ? Promise.resolve(P.uuid) : new Promise(function(e) {
      return ae(en, function(t, n) {
        return e(n);
      });
    });
  } };
  var Ir = function() {
    return Re(function e() {
      Ae(this, e), y(this, "items", {});
    }, [{ key: "getItem", value: function(e) {
      return Object.prototype.hasOwnProperty.call(this.items, e) ? this.items[e] : null;
    } }, { key: "removeItem", value: function(e) {
      delete this.items[e];
    } }, { key: "setItem", value: function(e, t) {
      this.items[e] = t;
    } }]);
  }(), xr = function() {
    return Re(function e() {
      var t = this;
      Ae(this, e), y(this, "defaultName", se.namespace), y(this, "storageName", this.defaultName), y(this, "storeNames", E.storeNames.left), this.storesMap = {}, an() ? this.storage = window.localStorage : this.storage = new Ir();
      var n = this.read.bind(this), r = this.write.bind(this);
      Ne(this.storeNames).forEach(function(o) {
        var i = o.name;
        Object.defineProperty(t.storesMap, i, { get: function() {
          return n(i);
        }, set: function(a) {
          r(i, a);
        } });
      }), Object.freeze(this.storesMap);
    }, [{ key: "read", value: function(e) {
      var t = this.storage.getItem("".concat(this.storageName, ".").concat(e)), n = t ? JSON.parse(t) : null;
      return e === Oe.Preferences && n ? Q(Oe.Preferences, S.right, n) : n;
    } }, { key: "write", value: function(e, t) {
      t ? this.storage.setItem("".concat(this.storageName, ".").concat(e), JSON.stringify(t instanceof Array ? t : Q(Oe.Preferences, S.left, t))) : this.storage.removeItem("".concat(this.storageName, ".").concat(e));
    } }, { key: "clear", value: function() {
      this.deleteData();
    } }, { key: "deleteData", value: function() {
      var e = this, t = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
      Ne(this.storeNames).forEach(function(n) {
        !t && n.permanent || e.storage.removeItem("".concat(e.storageName, ".").concat(n.name));
      });
    } }, { key: "setCustomName", value: function(e) {
      var t = this;
      if (e && e.length) {
        var n = "".concat(se.namespace, "-").concat(e);
        Ne(this.storeNames).forEach(function(r) {
          var o = r.name, i = t.storage.getItem("".concat(t.storageName, ".").concat(o));
          i && t.storage.setItem("".concat(n, ".").concat(o), i);
        }), this.deleteData(!0), this.storageName = n;
      }
    } }, { key: "stores", get: function() {
      return this.storesMap;
    } }]);
  }();
  const N = new xr();
  var Ce = Ie.preferences.name, fe = null;
  function At() {
    return fe || Rt(), fe ? m({}, fe) : null;
  }
  function Rt() {
    fe = N.stores[Ce];
  }
  function Et() {
    var e = At();
    return e && e.sdkDisabled || null;
  }
  function On(e) {
    var t = e ? m({}, e) : null;
    N.stores[Ce] = m(m({}, At()), {}, { sdkDisabled: t }), Rt();
  }
  function jt() {
    var e = N.stores[Ce] || {}, t = (fe || {}).sdkDisabled || null;
    e.sdkDisabled && !t && H("sdk:shutdown"), Rt();
  }
  function In() {
    N.stores[Ce] || (N.stores[Ce] = m({}, fe));
  }
  fe = At();
  var j = function(e) {
    return e.add = "add", e.put = "put", e.get = "get", e.list = "list", e.clear = "clear", e.delete = "delete", e;
  }(j || {}), Y = function(e) {
    return e.readonly = "readonly", e.readwrite = "readwrite", e;
  }(Y || {}), Ye = function() {
    function e() {
      Ae(this, e), y(this, "dbDefaultName", se.namespace), y(this, "dbName", this.dbDefaultName), y(this, "dbVersion", 1), y(this, "indexedDbConnection", null), y(this, "notSupportedError", { name: "IDBNotSupported", message: "IndexedDB is not supported" }), y(this, "databaseOpenError", { name: "CannotOpenDatabaseError", message: "Cannot open a database" }), y(this, "noConnectionError", { name: "NoDatabaseConnection", message: "Cannot open a transaction" });
      var t = e.getIndexedDB();
      if (!t) throw this.notSupportedError;
      this.idbFactory = t;
    }
    return Re(e, [{ key: "setCustomName", value: function(t) {
      return t && t.length > 0 ? (this.dbName = "".concat(se.namespace, "-").concat(t), this.migrateDb(this.dbDefaultName, this.dbName)) : Promise.resolve();
    } }, { key: "openDatabase", value: function(t, n, r) {
      var o = this;
      return e.isSupported().then(function(i) {
        return i ? new Promise(function(a, u) {
          var c = o.idbFactory.open(t, r);
          n && (c.onupgradeneeded = function(s) {
            return n(s, u);
          }), c.onsuccess = function(s) {
            var l = s.target.result;
            l ? a(l) : u(o.databaseOpenError);
          }, c.onerror = u;
        }) : Promise.reject(o.notSupportedError);
      });
    } }, { key: "databaseExists", value: function(t) {
      var n = this;
      return new Promise(function(r) {
        var o = !0;
        n.openDatabase(t, function() {
          o = !1;
        }).then(function(i) {
          if (i.close(), !o) return n.deleteDatabaseByName(t);
        }).then(function() {
          return r(o);
        });
      });
    } }, { key: "cloneData", value: function(t, n) {
      var r = this;
      return Ne(E.storeNames.left).map(function(o) {
        return o.name;
      }).filter(function(o) {
        return o !== "p";
      }).map(function(o) {
        return function() {
          return i = o, a = r.indexedDbConnection, r.indexedDbConnection = t, r.getAll(i).then(function(u) {
            if (r.indexedDbConnection = n, !(u.length < 1)) return r.addBulk(i, u, !0);
          }).then(function() {
            r.indexedDbConnection = a;
          });
          var i, a;
        };
      }).reduce(function(o, i) {
        return o.then(i);
      }, Promise.resolve());
    } }, { key: "migrateDb", value: function(t, n) {
      var r = this;
      return this.databaseExists(t).then(function(o) {
        return o ? Promise.all([r.openDatabase(t, r.handleUpgradeNeeded, r.dbVersion), r.openDatabase(n, r.handleUpgradeNeeded, r.dbVersion)]).then(function(i) {
          var a = k(i, 2), u = a[0], c = a[1];
          return r.cloneData(u, c).then(function() {
            return r.indexedDbConnection = c, u.close(), r.deleteDatabaseByName(t);
          });
        }).then(function() {
          return d.info("Database migration finished");
        }) : r.openDatabase(n, r.handleUpgradeNeeded, r.dbVersion).then(function(i) {
          r.indexedDbConnection = i;
        });
      });
    } }, { key: "handleUpgradeNeeded", value: function(t, n) {
      var r = t.target.result;
      t.target.transaction.onerror = n, t.target.transaction.onabort = n;
      var o = E.storeNames.left, i = h.current || {}, a = i && !ee(i);
      x(o).filter(function(u) {
        return !k(u, 2)[1].permanent;
      }).forEach(function(u) {
        var c = k(u, 2), s = c[0], l = c[1].name, g = E.right[s], f = r.createObjectStore(l, { keyPath: g.keyPath, autoIncrement: g.autoIncrement || !1 });
        if (g.index && f.createIndex("".concat(g.index, "Index"), g.index), l === ce.ActivityState && a) return f.add(Q(s, S.left, i)), void d.info("Activity state has been recovered");
        var p = N.stores[l];
        p && (p.forEach(function(v) {
          return f.add(v);
        }), d.info("Migration from localStorage done for ".concat(s, " store")));
      }), In(), N.clear();
    } }, { key: "open", value: function() {
      var t = this;
      return this.indexedDbConnection ? Promise.resolve({ success: !0 }) : this.openDatabase(this.dbName, this.handleUpgradeNeeded, this.dbVersion).then(function(n) {
        return t.indexedDbConnection = n, t.indexedDbConnection.onclose = function() {
          return t.destroy;
        }, { success: !0 };
      });
    } }, { key: "getTransactionStore", value: function(t, n, r) {
      var o, i = t.storeName, a = t.mode, u = r.transaction([i], a), c = u.objectStore(i), s = E.right[V(i, S.right)];
      return s.index && (o = c.index("".concat(s.index, "Index"))), u.onerror = n, u.onabort = n, { transaction: u, store: c, index: o, options: s };
    } }, { key: "overrideError", value: function(t, n) {
      var r = n.target.error;
      return t({ name: r.name, message: r.message });
    } }, { key: "getCompositeKeys", value: function(t) {
      var n = t.fields[t.keyPath];
      return Ve(n) ? n.composite : null;
    } }, { key: "targetIsObject", value: function(t) {
      return he(t);
    } }, { key: "prepareTarget", value: function(t, n, r) {
      if (r === j.clear || !n) return null;
      var o = this.getCompositeKeys(t);
      return [j.add, j.put].indexOf(r) !== -1 ? this.targetIsObject(n) ? o ? m(y({}, t.keyPath, o.map(function(i) {
        return n[i];
      }).join("")), n) : n : null : n instanceof Array ? n.join("") : n;
    } }, { key: "prepareResult", value: function(t, n) {
      var r = this.getCompositeKeys(t);
      return r && this.targetIsObject(n) ? r.map(function(o) {
        return n[o];
      }) : null;
    } }, { key: "initRequest", value: function(t) {
      var n = this, r = t.storeName, o = t.target, i = o === void 0 ? null : o, a = t.action, u = t.mode, c = u === void 0 ? Y.readonly : u;
      return this.open().then(function() {
        return new Promise(function(s, l) {
          if (n.indexedDbConnection) {
            var g = n.getTransactionStore({ storeName: r, mode: c }, l, n.indexedDbConnection), f = g.store, p = g.options, v = f[a](n.prepareTarget(p, i, a)), b = n.prepareResult(p, i);
            v.onsuccess = function() {
              a !== j.get || v.result ? s(b || v.result || i) : l({ name: "NotRecordFoundError", message: 'Requested record not found in "'.concat(r, '" store') });
            }, v.onerror = function(O) {
              return n.overrideError(l, O);
            };
          } else l(n.noConnectionError);
        });
      });
    } }, { key: "initBulkRequest", value: function(t) {
      var n = this, r = t.storeName, o = t.target, i = t.action, a = t.mode, u = a === void 0 ? Y.readwrite : a;
      return !o || o && !o.length ? Promise.reject({ name: "NoTargetDefined", message: "No array provided to perform ".concat(i, ' bulk operation into "').concat(r, '" store') }) : this.open().then(function() {
        return new Promise(function(c, s) {
          if (n.indexedDbConnection) {
            var l = n.getTransactionStore({ storeName: r, mode: u }, s, n.indexedDbConnection), g = l.transaction, f = l.store, p = l.options, v = new Array(), b = o[0];
            g.oncomplete = function() {
              return c(v);
            }, function O(M) {
              M.onerror = function(z) {
                return n.overrideError(s, z);
              }, M.onsuccess = function() {
                v.push(n.prepareResult(p, b) || M.result), b = o[v.length], v.length < o.length && O(f[i](n.prepareTarget(p, b, i)));
              };
            }(f[i](n.prepareTarget(p, b, i)));
          } else s(n.noConnectionError);
        });
      });
    } }, { key: "openCursor", value: function(t) {
      var n = this, r = t.storeName, o = t.action, i = t.range, a = i === void 0 ? null : i, u = t.firstOnly, c = u !== void 0 && u, s = t.mode, l = s === void 0 ? Y.readonly : s;
      return this.open().then(function() {
        return new Promise(function(g, f) {
          if (n.indexedDbConnection) {
            var p = n.getTransactionStore({ storeName: r, mode: l }, f, n.indexedDbConnection), v = p.transaction, b = p.store, O = p.index, M = p.options, z = (O || b).openCursor(a), L = new Array();
            v.oncomplete = function() {
              return g(L);
            }, z.onsuccess = function(A) {
              var K = A.target.result;
              K && (o === j.delete ? (K.delete(), L.push(n.prepareResult(M, K.value) || K.value[M.keyPath])) : L.push(K.value), c || K.continue());
            }, z.onerror = function(A) {
              return n.overrideError(f, A);
            };
          } else f(n.noConnectionError);
        });
      });
    } }, { key: "deleteDatabaseByName", value: function(t) {
      var n = this;
      return new Promise(function(r, o) {
        var i = n.idbFactory.deleteDatabase(t);
        i.onerror = function(a) {
          return n.overrideError(o, a);
        }, i.onsuccess = function() {
          return r();
        }, i.onblocked = function(a) {
          return o(a.target);
        };
      });
    } }, { key: "getAll", value: function(t) {
      var n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      return this.openCursor({ storeName: t, action: j.list, firstOnly: n });
    } }, { key: "getFirst", value: function(t) {
      return this.getAll(t, !0).then(function(n) {
        return n.length ? n[0] : void 0;
      });
    } }, { key: "getItem", value: function(t, n) {
      return this.initRequest({ storeName: t, target: n, action: j.get });
    } }, { key: "filterBy", value: function(t, n) {
      var r = IDBKeyRange.only(n);
      return this.openCursor({ storeName: t, action: j.list, range: r });
    } }, { key: "addItem", value: function(t, n) {
      return this.initRequest({ storeName: t, target: n, action: j.add, mode: Y.readwrite });
    } }, { key: "addBulk", value: function(t, n, r) {
      return this.initBulkRequest({ storeName: t, target: n, action: r ? j.put : j.add, mode: Y.readwrite });
    } }, { key: "updateItem", value: function(t, n) {
      return this.initRequest({ storeName: t, target: n, action: j.put, mode: Y.readwrite });
    } }, { key: "deleteItem", value: function(t, n) {
      return this.initRequest({ storeName: t, target: n, action: j.delete, mode: Y.readwrite });
    } }, { key: "deleteBulk", value: function(t, n, r) {
      var o = r ? IDBKeyRange[r](n) : IDBKeyRange.only(n);
      return this.openCursor({ storeName: t, action: j.delete, range: o, mode: Y.readwrite });
    } }, { key: "trimItems", value: function(t, n) {
      var r = this, o = E.right[V(t, S.right)];
      return this.getAll(t).then(function(i) {
        return i.length ? i[n - 1] : null;
      }).then(function(i) {
        return i ? r.deleteBulk(t, i[o.keyPath], xe.UpperBound) : [];
      });
    } }, { key: "count", value: function(t) {
      var n = this;
      return this.open().then(function() {
        return new Promise(function(r, o) {
          if (n.indexedDbConnection) {
            var i = n.getTransactionStore({ storeName: t, mode: Y.readonly }, o, n.indexedDbConnection).store.count();
            i.onsuccess = function() {
              return r(i.result);
            }, i.onerror = function(a) {
              return n.overrideError(o, a);
            };
          } else o(n.noConnectionError);
        });
      });
    } }, { key: "clear", value: function(t) {
      return this.initRequest({ storeName: t, action: j.clear, mode: Y.readwrite });
    } }, { key: "destroy", value: function() {
      this.indexedDbConnection && this.indexedDbConnection.close(), this.indexedDbConnection = null;
    } }, { key: "deleteDatabase", value: function() {
      return this.destroy(), this.deleteDatabaseByName(this.dbName);
    } }], [{ key: "tryOpen", value: function(t) {
      return new Promise(function(n) {
        try {
          var r = t.open(e.dbValidationName);
          r.onsuccess = function() {
            r.result.close(), t.deleteDatabase(e.dbValidationName), n(!0);
          }, r.onerror = function() {
            return n(!1);
          };
        } catch (o) {
          n(!1);
        }
      });
    } }, { key: "isSupported", value: function() {
      if (e.isSupportedPromise) return e.isSupportedPromise;
      var t = "IndexedDB is not supported in this browser";
      return e.isSupportedPromise = new Promise(function(n) {
        var r = e.getIndexedDB(), o = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        !r || o ? (d.warn(t), n(!1)) : n(e.tryOpen(r).then(function(i) {
          return i || d.warn(t), i;
        }));
      }), e.isSupportedPromise;
    } }, { key: "getIndexedDB", value: function() {
      return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
    } }]);
  }();
  function ze(e) {
    return function(t) {
      if (Array.isArray(t)) return gt(t);
    }(e) || function(t) {
      if (typeof Symbol != "undefined" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
    }(e) || pt(e) || function() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }();
  }
  y(Ye, "dbValidationName", "validate-db-openable"), y(Ye, "isSupportedPromise", null);
  var Ct = function() {
    function e() {
      Ae(this, e);
    }
    return Re(e, [{ key: "open", value: function() {
      return e.isSupported().then(function(t) {
        if (!t) return { status: "error", error: { name: "LSNotSupported", message: "LocalStorage is not supported" } };
        var n = E.storeNames.left, r = h.current || {}, o = r && !ee(r);
        return x(n).filter(function(i) {
          return !k(i, 2)[1].permanent;
        }).forEach(function(i) {
          var a = k(i, 2), u = a[0], c = a[1].name;
          c !== ce.ActivityState || N.stores[c] ? N.stores[c] || (N.stores[c] = []) : N.stores[c] = o ? [Q(u, S.left, r)] : [];
        }), In(), { status: "success" };
      });
    } }, { key: "getCompositeKeys", value: function(t) {
      var n = t.fields[t.keyPath];
      return Ve(n) ? n.composite : null;
    } }, { key: "getKeys", value: function(t) {
      var n = V(t, S.right), r = E.right[n];
      return this.getCompositeKeys(r) || [r.keyPath];
    } }, { key: "nextIndex", value: function(t) {
      return typeof t == "number" ? t + 1 : void 0;
    } }, { key: "initRequest", value: function(t, n) {
      var r = this, o = t.storeName, i = t.id, a = t.item, u = E.right[V(o, S.right)];
      return this.open().then(function(c) {
        return c.status === "error" ? Promise.reject(c.error) : new Promise(function(s, l) {
          var g, f = N.stores[o], p = r.getKeys(o), v = (f[f.length - 1] || {})[u.keyPath] || 0;
          if (i) {
            var b = Array.isArray(i) ? i.slice() : [i];
            g = p.map(function(M, z) {
              return [M, b[z]];
            }).reduce(R, {});
          } else g = m({}, a);
          var O = g ? rn(f, p, g) : 0;
          return n(s, l, { keys: p, items: f, index: O, options: u, lastId: v });
        });
      });
    } }, { key: "sort", value: function(t, n, r) {
      var o = ze(t), i = n.slice().reverse();
      return o.sort(function(a, u) {
        return i.reduce(function(c, s) {
          return c || function(l, g, f) {
            var p = r ? r === l[f] : l[f] < g[f], v = r ? r > l[f] : l[f] > g[f];
            return p ? -1 : v ? 1 : 0;
          }(a, u, s);
        }, 0);
      });
    } }, { key: "prepareTarget", value: function(t, n, r) {
      var o = this.getCompositeKeys(t);
      return o ? m(y({}, t.keyPath, o.map(function(i) {
        return n[i];
      }).join("")), n) : t.autoIncrement && r ? m(y({}, t.keyPath, r), n) : m({}, n);
    } }, { key: "prepareResult", value: function(t, n) {
      var r = this.getCompositeKeys(t);
      return r ? r.map(function(o) {
        return n[o];
      }).filter(function(o) {
        return !hn(o);
      }) : n[t.keyPath];
    } }, { key: "getAll", value: function(t) {
      var n = this, r = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
      return this.open().then(function(o) {
        return o.status === "error" ? Promise.reject(o.error) : new Promise(function(i, a) {
          var u = N.stores[t];
          u instanceof Array ? i(r ? [u[0]] : n.sort(u, n.getKeys(t))) : a({ name: "NotFoundError", message: "No objectStore named ".concat(t, " in this database") });
        });
      });
    } }, { key: "getFirst", value: function(t) {
      return this.getAll(t, !0).then(function(n) {
        return n.length ? n[0] : void 0;
      });
    } }, { key: "getItem", value: function(t, n) {
      var r = this;
      return this.initRequest({ storeName: t, id: n }, function(o, i, a) {
        var u = a.items, c = a.index, s = a.options;
        c === -1 ? i({ name: "NotRecordFoundError", message: 'Requested record not found in "'.concat(t, '" store') }) : o(r.prepareTarget(s, u[c]));
      });
    } }, { key: "filterBy", value: function(t, n) {
      return this.getAll(t).then(function(r) {
        return r.filter(function(o) {
          var i = E.right[V(t, S.right)];
          return (i.index && o[i.index]) === n;
        });
      });
    } }, { key: "addItem", value: function(t, n) {
      var r = this;
      return this.initRequest({ storeName: t, item: n }, function(o, i, a) {
        var u = a.items, c = a.index, s = a.options, l = a.lastId;
        c !== -1 ? i({ name: "ConstraintError", message: 'Constraint was not satisfied, trying to add existing item into "'.concat(t, '" store') }) : (u.push(r.prepareTarget(s, n, r.nextIndex(l))), N.stores[t] = u, o(r.prepareResult(s, n)));
      });
    } }, { key: "addBulk", value: function(t, n, r) {
      var o = this;
      return this.initRequest({ storeName: t }, function(i, a, u) {
        var c = u.keys, s = u.items, l = u.options, g = u.lastId;
        if (!n || n && !n.length) a({ name: "NoTargetDefined", message: 'No array provided to perform add bulk operation into "'.concat(t, '" store') });
        else {
          var f = g, p = n.map(function(O) {
            return o.prepareTarget(l, O, f = o.nextIndex(f));
          }), v = p.filter(function(O) {
            return rn(s, c, O) !== -1;
          }).map(function(O) {
            return O[l.keyPath];
          }), b = r ? s.filter(function(O) {
            return v.indexOf(O[l.keyPath]) === -1;
          }) : ze(s);
          v.length && !r ? a({ name: "ConstraintError", message: 'Constraint was not satisfied, trying to add existing items into "'.concat(t, '" store') }) : (N.stores[t] = o.sort([].concat(ze(b), ze(p)), c), i(n.map(function(O) {
            return o.prepareResult(l, O);
          })));
        }
      });
    } }, { key: "updateItem", value: function(t, n) {
      var r = this;
      return this.initRequest({ storeName: t, item: n }, function(o, i, a) {
        var u = a.items, c = a.index, s = a.options, l = a.lastId, g = c === -1 ? r.nextIndex(l) : void 0, f = r.prepareTarget(s, n, g);
        c === -1 ? u.push(f) : u.splice(c, 1, f), N.stores[t] = u, o(r.prepareResult(s, n));
      });
    } }, { key: "deleteItem", value: function(t, n) {
      return this.initRequest({ storeName: t, id: n }, function(r, o, i) {
        var a = i.items, u = i.index;
        u !== -1 && (a.splice(u, 1), N.stores[t] = a), r(n);
      });
    } }, { key: "findMax", value: function(t, n, r) {
      if (!t.length) return -1;
      for (var o = { index: -1, value: typeof r == "string" ? "" : 0 }, i = 0; i < t.length; i += 1) {
        if (!(t[i][n] <= r)) return o.index;
        t[i][n] >= o.value && (o = { value: t[i][n], index: i });
      }
      return o.index;
    } }, { key: "deleteBulk", value: function(t, n, r) {
      var o = this;
      return this.getAll(t).then(function(i) {
        var a = o.getKeys(t), u = E.right[V(t, S.right)].index || a[0], c = r ? null : n, s = o.sort(i, a, c), l = o.findMax(s, u, n);
        if (l === -1) return [];
        var g = r === xe.LowerBound ? l : 0, f = r && r !== xe.UpperBound ? s.length : l + 1, p = s.splice(g, f).map(function(v) {
          return a.length === 1 ? v[u] : a.map(function(b) {
            return v[b];
          });
        });
        return N.stores[t] = s, p;
      });
    } }, { key: "trimItems", value: function(t, n) {
      var r = this, o = V(t, S.right), i = E.right[o];
      return this.getAll(t).then(function(a) {
        return a.length ? a[n - 1] : null;
      }).then(function(a) {
        return a ? r.deleteBulk(t, a[i.keyPath], xe.UpperBound) : [];
      });
    } }, { key: "count", value: function(t) {
      return this.open().then(function(n) {
        if (n.status === "error") return Promise.reject(n.error);
        var r = N.stores[t];
        return Promise.resolve(r instanceof Array ? r.length : 1);
      });
    } }, { key: "clear", value: function(t) {
      return this.open().then(function(n) {
        return n.status === "error" ? Promise.reject(n.error) : new Promise(function(r) {
          N.stores[t] = [], r();
        });
      });
    } }, { key: "destroy", value: function() {
    } }, { key: "deleteDatabase", value: function() {
    } }], [{ key: "isSupported", value: function() {
      return e.isSupportedPromise || (e.isSupportedPromise = new Promise(function(t) {
        var n = an();
        n || d.warn("LocalStorage is not supported in this browser"), t(n);
      })), e.isSupportedPromise;
    } }]);
  }();
  y(Ct, "isSupportedPromise", null);
  var _e, Je = function(e) {
    return e[e.noStorage = ve.NO_STORAGE] = "noStorage", e[e.indexedDB = ve.INDEXED_DB] = "indexedDB", e[e.localStorage = ve.LOCAL_STORAGE] = "localStorage", e;
  }(Je || {}), Ar = { getAll: function(e, t, n) {
    return e.getAll(t, n).then(function(r) {
      return Dt(t, S.right, r);
    });
  }, getFirst: function(e, t) {
    return e.getFirst(t).then(function(n) {
      return Q(t, S.right, n);
    });
  }, getItem: function(e, t, n) {
    return e.getItem(t, le(t, S.left, n)).then(function(r) {
      return Q(t, S.right, r);
    }).catch(function(r) {
      return Promise.reject(Nt(t, r));
    });
  }, filterBy: function(e, t, n) {
    return e.filterBy(t, bn(n)).then(function(r) {
      return Dt(t, S.right, r);
    });
  }, addItem: function(e, t, n) {
    var r = Q(t, S.left, n);
    return e.addItem(t, r).then(function(o) {
      return le(t, S.right, o);
    }).catch(function(o) {
      return Promise.reject(Nt(t, o));
    });
  }, addBulk: function(e, t, n, r) {
    var o = Dt(t, S.left, n);
    return e.addBulk(t, o, r).then(function(i) {
      return i.map(function(a) {
        return le(t, S.right, a);
      });
    }).catch(function(i) {
      return Promise.reject(Nt(t, i));
    });
  }, updateItem: function(e, t, n) {
    var r = Q(t, S.left, n);
    return e.updateItem(t, r).then(function(o) {
      return le(t, S.right, o);
    });
  }, deleteItem: function(e, t, n) {
    return e.deleteItem(t, le(t, S.left, n)).then(function(r) {
      return le(t, S.right, r);
    });
  }, deleteBulk: function(e, t, n, r) {
    return e.deleteBulk(t, bn(n), r).then(function(o) {
      return o.map(function(i) {
        return le(t, S.right, i);
      });
    });
  }, trimItems: function(e, t, n) {
    return e.trimItems(t, n);
  }, count: function(e, t) {
    return e.count(t);
  }, clear: function(e, t) {
    return e.clear(t);
  }, destroy: function(e) {
    return e.destroy();
  }, deleteDatabase: function(e) {
    return e.deleteDatabase();
  } }, _t = null;
  function xn(e) {
    var t = null;
    return _t !== null ? _t : _t = Promise.all([Ye.isSupported(), Ct.isSupported()]).then(function(n) {
      var r = k(n, 2), o = r[0], i = r[1];
      if (N.setCustomName(e), o) {
        _e = Je.indexedDB;
        var a = new Ye();
        return a.setCustomName(e).then(function() {
          return t = a;
        });
      }
      return i ? (_e = Je.localStorage, t = new Ct(), Promise.resolve(t)) : (d.error("There is no storage available, app will run with minimum set of features"), _e = Je.noStorage, t = null, Promise.resolve(t));
    }).then(function() {
      return { type: _e, storage: t };
    });
  }
  const w = m({ init: xn, getType: function() {
    return _e;
  } }, (An = x(Ar).map(function(e) {
    var t = k(e, 2), n = t[0], r = t[1];
    return [n, function(o) {
      for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), u = 1; u < i; u++) a[u - 1] = arguments[u];
      return xn().then(function(c) {
        var s = c.storage;
        if (s) return r.call.apply(r, [null, s, V(o, S.left)].concat(a));
      });
    }];
  }), An.reduce(R, {})));
  var An;
  function Rr() {
    return w.getAll("queue").then(function(e) {
      return { queueSize: e.length };
    }).then(function(e) {
      return m(m(m(m(m(m(m(m({}, { createdAt: Ee() }), { sentAt: Ee() }), { webUuid: h.current.uuid }), (n = navigator, r = n.doNotTrack !== void 0, o = window.doNotTrack !== void 0, i = n.msDoNotTrack !== void 0, a = r ? n.doNotTrack : o ? window.doNotTrack : i ? n.msDoNotTrack : null, parseInt(a, 10) === 0 || a === "no" ? { trackingEnabled: !0 } : parseInt(a, 10) === 1 || a === "yes" ? { trackingEnabled: !1 } : null)), { platform: "web" }), function() {
        var u = navigator, c = k((u.language || u.userLanguage || "en").split("-"), 2), s = c[0], l = c[1];
        return { language: s, country: l ? "" + l.toLowerCase() : void 0 };
      }()), (t = navigator.userAgent || navigator.vendor, { machineType: navigator.platform !== "Win32" || t.indexOf("WOW64") === -1 && t.indexOf("Win64") === -1 ? navigator.platform : "Win64" })), e);
      var t, n, r, o, i, a;
    });
  }
  function Qe(e, t) {
    return { status: "error", action: arguments.length > 2 && arguments[2] !== void 0 && arguments[2] ? "CONTINUE" : "RETRY", response: nn(e.responseText) ? JSON.parse(e.responseText) : e.responseText, message: mt[t], code: t };
  }
  function Rn(e, t) {
    var n = e.slice(0, e.length - t.length - 1).split("").reduce(function(r) {
      return r.concat(" ");
    }, "");
    return "".concat(t).concat(n, ":");
  }
  function Er(e, t) {
    var n = "REQUEST PARAMETERS:", r = function(i) {
      return i.replace(/([A-Z])/g, function(a) {
        return "_".concat(a.toLowerCase());
      });
    }, o = x(m(m(m({}, _.getBaseParams()), t), e)).map(function(i) {
      var a = k(i, 2), u = a[0], c = a[1];
      return [r(u), c];
    });
    return d.log(n), o.filter(function(i) {
      return vt(k(i, 2)[1]);
    }).map(function(i) {
      var a = k(i, 2), u = a[0], c = a[1];
      return d.log(Rn(n, u), c), function(s) {
        var l = k(s, 2), g = l[0], f = l[1], p = encodeURIComponent(g), v = f;
        return typeof f == "string" && (v = encodeURIComponent(f)), he(f) && (v = encodeURIComponent(JSON.stringify(f) || "")), [p, v].join(g === "granular_third_party_sharing_options" || g === "partner_sharing_settings" ? encodeURIComponent("=") : "=");
      }([u, c]);
    }).join("&");
  }
  function jr(e, t, n) {
    var r = n.xhr, o = n.url;
    if (r.readyState === 4) {
      var i = r.status >= 200 && r.status < 300, a = nn(r.responseText);
      if (r.status !== 0) return a ? t(i ? function(u, c) {
        var s = JSON.parse(u.responseText), l = { status: "success", adid: s.adid, timestamp: s.timestamp, ask_in: s.ask_in, retry_in: s.retry_in, continue_in: s.continue_in, tracking_state: s.tracking_state, attribution: void 0, message: void 0 };
        return oe(c, "attribution") && (l.attribution = s.attribution, l.message = s.message), x(l).filter(function(g) {
          return !!k(g, 2)[1];
        }).reduce(R, {});
      }(r, o) : Qe(r, "SERVER_CANNOT_PROCESS", !0)) : e(Qe(r, i ? "SERVER_MALFORMED_RESPONSE" : "SERVER_INTERNAL_ERROR"));
      e(Qe(r, "NO_CONNECTION"));
    }
  }
  function Cr(e, t) {
    var n = e.endpoint, r = e.url, o = e.method, i = o === void 0 ? "GET" : o, a = e.params, u = function(l, g) {
      var f = l.endpoint, p = l.url, v = l.method, b = Er(l.params, g);
      return { fullUrl: f + p + (v === "GET" ? "?".concat(b) : ""), encodedParams: b };
    }({ endpoint: n, url: r, method: i, params: a === void 0 ? {} : a }, t), c = u.fullUrl, s = u.encodedParams;
    return new Promise(function(l, g) {
      var f = new XMLHttpRequest();
      f.open(i, c, !0), function(p, v) {
        var b = "REQUEST HEADERS:", O = [["Client-SDK", "js".concat(se.version)], ["Content-Type", v === "POST" ? "application/x-www-form-urlencoded" : "application/json"]];
        d.log(b), O.forEach(function(M) {
          var z = k(M, 2), L = z[0], A = z[1];
          p.setRequestHeader(L, A), d.log(Rn(b, L), A);
        });
      }(f, i), f.onreadystatechange = function() {
        return jr(g, l, { xhr: f, url: r });
      }, f.onerror = function() {
        return g(Qe(f, "TRANSACTION_ERROR"));
      }, f.send(i === "GET" ? void 0 : s);
    });
  }
  function _r(e, t) {
    return e.status === "success" ? function(n, r) {
      var o = oe(r, "gdpr_forget_device"), i = oe(r, "attribution"), a = oe(r, "session"), u = n.tracking_state === "opted_out";
      return !o && u ? (H("sdk:gdpr-forget-me"), n) : (i || o || u || !n.ask_in || H("attribution:check", n), a && H("session:finished", n), n);
    }(e, t) : e;
  }
  var Tr = { long: { delay: 12e4, maxDelay: Zt, minRange: 0.5, maxRange: 1 }, short: { delay: 200, maxDelay: Xt, minRange: 0.5, maxRange: 1 }, test: { delay: 100, maxDelay: 300 } };
  function Br(e, t) {
    var n, r, o = Tr[t = t || "long"], i = o.delay * Math.pow(2, e - 1);
    return i = Math.min(i, o.maxDelay), o.minRange && o.maxRange && (i *= (n = o.minRange, r = o.maxRange, Math.random() * (r - n) + n)), Math.round(i);
  }
  var Tt = navigator.onLine;
  function En() {
    Tt = !0;
  }
  function jn() {
    Tt = !1;
  }
  function Xe(e, t, n) {
    e.addEventListener && e.addEventListener(t, n, !1);
  }
  function Ze(e, t, n) {
    e.removeEventListener && e.removeEventListener(t, n, !1);
  }
  function Bt(e) {
    return { domains: [e.default, e.world], useSubdomains: !0, isDataResidency: !1 };
  }
  var Ut = function(e) {
    return e.Default = "default", e.India = "india", e.China = "china", e;
  }(Ut || {});
  function Cn(e, t) {
    d.warn("Both ".concat(e, " and ").concat(t, " are set in config, ").concat(t, " will be ignored"));
  }
  function Ur(e) {
    return function(t) {
      var n = _.getCustomConfig(), r = n.customUrl, o = n.urlStrategy, i = n.dataResidency;
      if (r) return d.warn("customUrl is deprecated, use urlStrategy instead"), (i || o) && Cn("customUrl", i ? "dataResidency" : "urlStrategy"), { domains: [r], useSubdomains: !1, isDataResidency: !1 };
      if (i && o && Cn("dataResidency", "urlStrategy"), i) return d.warn("dataResidency is deprecated, use urlStrategy instead"), { domains: [t[i]], useSubdomains: !0, isDataResidency: !0 };
      if (typeof o == "string") {
        if (d.warn("urlStrategy string literals ('china' and 'india') are deprected, use UrlStartegyConfig instead"), o === Ut.India) return { domains: [t.india, t.default], useSubdomains: !0, isDataResidency: !1 };
        if (o === Ut.China) return { domains: [t.china, t.default], useSubdomains: !0, isDataResidency: !1 };
      }
      return o ? null : Bt(t);
    }(e) || function(t) {
      var n = _.getCustomConfig().urlStrategy;
      if (n && F(n) === "object") {
        var r = n;
        return !r.domains || !Array.isArray(r.domains) || r.domains.length < 1 ? (d.warn("Invalid urlStartegy: `domains` should be a non-empty array"), Bt(t)) : { domains: r.domains, useSubdomains: !!r.useSubdomains, isDataResidency: !!r.isDataResidency };
      }
      return Bt(t);
    }(e);
  }
  function Lr(e) {
    var t, n = Ur(e), r = [], o = function(u, c) {
      var s = typeof Symbol != "undefined" && u[Symbol.iterator] || u["@@iterator"];
      if (!s) {
        if (Array.isArray(u) || (s = pt(u)) || c) {
          s && (u = s);
          var l = 0, g = function() {
          };
          return { s: g, n: function() {
            return l >= u.length ? { done: !0 } : { done: !1, value: u[l++] };
          }, e: function(b) {
            throw b;
          }, f: g };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var f, p = !0, v = !1;
      return { s: function() {
        s = s.call(u);
      }, n: function() {
        var b = s.next();
        return p = b.done, b;
      }, e: function(b) {
        v = !0, f = b;
      }, f: function() {
        try {
          p || s.return == null || s.return();
        } finally {
          if (v) throw f;
        }
      } };
    }(n.domains);
    try {
      for (o.s(); !(t = o.n()).done; ) {
        var i = t.value, a = n.useSubdomains ? { app: "".concat("https://app.").concat(i), gdpr: "".concat("https://gdpr.").concat(i) } : { app: "".concat($t).concat(i), gdpr: "".concat($t).concat(i) };
        r.push(a);
      }
    } catch (u) {
      o.e(u);
    } finally {
      o.f();
    }
    return r;
  }
  var $e = 150, _n = 2147483647, Lt = 6e4;
  const Kt = function() {
    var e, t, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.url, o = n.method, i = o === void 0 ? "GET" : o, a = n.params, u = a === void 0 ? {} : a, c = n.continueCb, s = n.strategy, l = n.wait, g = { url: r, method: i, params: u, continueCb: c }, f = r, p = i, v = m({}, u), b = c, O = s, M = function() {
      e.reset(), t = e.next();
    }, z = function(D, q) {
      return D[q === "/gdpr_forget_device" ? "gdpr" : "app"];
    }, L = null, A = { request: 0, connection: 0 }, K = ir(l), Pe = null;
    function ir(D) {
      return (D = D || $e) > _n ? _n : D;
    }
    function ar(D) {
      var q = D.wait, De = D.retrying;
      return e || (e = function() {
        var X = Lr(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : hr), ne = 0;
        return { next: function() {
          return ne < X.length ? { value: X[ne++], done: !1 } : { value: void 0, done: !0 };
        }, reset: function() {
          ne = 0;
        } };
      }(), t = e.next()), K = q ? ir(q) : K, function(X) {
        if (!Pe) return !1;
        if (L) {
          var ne = K - (Date.now() - Pe);
          if (X && ne < X) return !0;
          lt();
        }
        return !1;
      }(q) ? Promise.resolve({ status: "error", action: "CONTINUE", response: "", message: mt.SKIP, code: "SKIP" }) : f ? (d.log("".concat(De ? "Re-trying" : "Trying", " request ").concat(f, " in ").concat(K, "ms")), Pe = Date.now(), ur({ endpoint: z(t.value, f), url: f, method: p, params: m({ attempts: 1 }, v) })) : (d.error("You must define url for the request to be sent"), Promise.reject({ status: "error", action: "CONTINUE", response: "", message: mt.MISSING_URL, code: "MISSING_URL" }));
    }
    function ur(D) {
      return cr(), Tt ? function(q) {
        return new Promise(function(De, X) {
          L = setTimeout(function() {
            Pe = null;
            var ne = x(q.params).filter(function(Z) {
              return vt(k(Z, 2)[1]);
            }).reduce(R, {});
            return function(Z) {
              return Rr().then(function(C) {
                return Cr(Z, C);
              }).then(function(C) {
                return _r(C, Z.url);
              });
            }({ endpoint: q.endpoint, url: q.url, method: q.method, params: m(m({}, ne), {}, { attempts: (A.request ? A.request + 1 : 1) + A.connection }) }).then(function(Z) {
              return function(C, J) {
                C && C.retry_in ? J(Le(C.retry_in)) : (M(), typeof b == "function" ? b(C, Jt, Le) : Jt(), J(C));
              }(Z, De);
            }).catch(function(Z) {
              return function(C, J, dt) {
                if (C && C.action === "RETRY") if (C.code === "NO_CONNECTION") {
                  var Ke = e.next();
                  Ke.done ? (M(), J(Le(Lt))) : (t = Ke, J(Le($e)));
                } else J(Le());
                else Jt(!0), dt(C || {});
              }(Z, De, X);
            });
          }, K);
        });
      }(D) : (A.connection += 1, d.log("No internet connectivity, trying request ".concat(D.url, " in ").concat(Lt, "ms")), new Promise(function(q) {
        L = setTimeout(function() {
          q(ur(D));
        }, Lt);
      }));
    }
    function sr() {
      f = g.url, p = g.method, v = m({}, g.params), b = g.continueCb;
    }
    function Jt(D) {
      d.log("Request ".concat(f || "unknown", " ").concat(D ? "failed" : "has been finished")), A.request = 0, A.connection = 0, K = $e, sr(), lt();
    }
    function Le(D) {
      return A.request += 1, lt(), ar({ wait: D || Br(A.request, O), retrying: !0 });
    }
    function cr() {
      L && clearTimeout(L), L = null;
    }
    function lt() {
      var D = !!Pe;
      cr(), Pe = null, D && (K = $e, A.request = 0, A.connection = 0, d.log("Previous ".concat(f || "unknown", " request attempt canceled")), sr());
    }
    return { send: function() {
      var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, q = D.url, De = D.method, X = D.params, ne = X === void 0 ? {} : X, Z = D.continueCb, C = D.wait;
      return function(J) {
        var dt = J.url, Ke = J.method, lr = J.params, dr = J.continueCb;
        dt && (f = dt), Ke && (p = Ke), ee(lr) || (v = m({}, lr)), v = m({ createdAt: Ee() }, v), typeof dr == "function" && (b = dr);
      }({ url: q, method: De, params: ne, continueCb: Z }), ar({ wait: C });
    }, isRunning: function() {
      return !!L;
    }, clear: lt };
  };
  var et = function(e) {
    return e === W.REASON_GDPR ? "GDPR disable" : "disable";
  }, Tn = function(e) {
    return { start: { inProgress: "Adjust SDK ".concat(et(e), " process has already started"), done: "Adjust SDK ".concat(et(e), " process is now started") }, finish: { inProgress: "Adjust SDK ".concat(et(e), " process has already finished"), done: "Adjust SDK ".concat(et(e), " process is now finished") } };
  };
  function Bn(e, t) {
    var n = e.reason, r = e.pending, o = Et() || {}, i = o.reason, a = o.pending, u = t === "start" && a ? "start" : "finish";
    return t === "start" && i || t === "finish" && i && !a ? (d.log(Tn(i)[u].inProgress), !1) : (d.log(Tn(n)[u].done), On({ reason: n || W.REASON_GENERAL, pending: r }), !0);
  }
  function qt(e) {
    return Bn({ reason: e, pending: arguments.length > 1 && arguments[1] !== void 0 && arguments[1] }, "start");
  }
  function te() {
    var e = Et() || {}, t = e.reason, n = e.pending;
    return t === W.REASON_GENERAL || t === W.REASON_GDPR && !n ? "off" : t === W.REASON_GDPR && n ? "paused" : "on";
  }
  var ke = dn.ActivityState, tt = !1;
  function Kr(e) {
    return e ? e.uuid === "unknown" ? (qt(W.REASON_GDPR), h.destroy(), { exists: !0, stored: null }) : (h.init(e), { exists: !0, stored: e }) : { exists: !1 };
  }
  function Un() {
    return te() !== "off" && h.isStarted();
  }
  function me() {
    if (!Un()) return Promise.resolve(null);
    var e = m(m({}, h.current), {}, { lastActive: Date.now() });
    return w.updateItem(ke, e).then(function() {
      return h.current = e;
    });
  }
  var Ln = Kt({ strategy: "long", continueCb: function(e, t) {
    var n = e && e.continue_in || null;
    return B.pause = n ? { timestamp: Date.now(), wait: n } : null, w.getFirst(Se).then(function(r) {
      return r ? w.deleteItem(Se, r.timestamp) : null;
    }).then(function() {
      var r, o = e.status === "error" || ((r = e.response) === null || r === void 0 ? void 0 : r.error);
      return t(o), B.running = !1, ot({ wait: n });
    });
  } }), nt = !1, Se = "queue", B = { running: !1, timestamp: null, pause: null };
  function qr() {
    var e = Date.now();
    return B.timestamp && e <= B.timestamp && (e = B.timestamp + 1), B.timestamp = e, e;
  }
  function rt(e) {
    var t = e.url, n = e.method, r = e.params, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = o.auto, a = o.timestamp;
    h.updateParams(t, i);
    var u = x(r || {}).filter(function(s) {
      return vt(k(s, 2)[1]);
    }).reduce(R, {}), c = { timestamp: qr(), url: t, method: n, params: m(m({}, h.getParams(t)), u) };
    return a && (c.createdAt = a), w.addItem(Se, c).then(function() {
      return function(s) {
        return oe(s, "session") && h.resetSessionOffset(), h.updateLastActive(), me();
      }(t);
    }).then(function() {
      return B.running ? {} : ot();
    });
  }
  function Gr() {
    var e = B.pause || {}, t = e.timestamp, n = e.wait, r = Date.now() - (t || 0);
    return r < n ? n - r : null;
  }
  function ot() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.cleanUp, n = e.wait;
    if (B.running) return Promise.resolve({});
    B.running = !0;
    var r = Promise.resolve({});
    return t && (r = r.then(Mr)), r.then(function() {
      return w.getFirst(Se);
    }).then(function(o) {
      return function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = i.timestamp, u = i.createdAt, c = i.url, s = i.method, l = i.params, g = arguments.length > 1 ? arguments[1] : void 0, f = h.current || {}, p = c === "/session" && !f.installed;
        return nt && !p || !c && !s && !l ? (B.running = !1, Promise.resolve({})) : Ln.send({ url: c, method: s, params: m(m({}, l), {}, { createdAt: Ee(u || a) }), wait: g || Gr() });
      }(o, n);
    });
  }
  function Kn(e) {
    if (e !== void 0) if (e !== nt) {
      var t = nt;
      nt = e, !e && t && ot(), d.info("The app is now in ".concat(e ? "offline" : "online", " mode"));
    } else d.error("The app is already in ".concat(e ? "offline" : "online", " mode"));
    else d.error("State not provided, true or false has to be defined");
  }
  function Mr() {
    var e = Date.now() - _.requestValidityWindow;
    return w.deleteBulk(Se, e, "upperBound");
  }
  var ge = "globalParams", Gt = "No type provided", Mt = "Global parameter type not provided, `callback` or `partner` types are available";
  function qn(e) {
    return (e || []).map(function(t) {
      return { key: t.key, value: t.value };
    });
  }
  function Gn() {
    return Promise.all([w.filterBy(ge, "callback"), w.filterBy(ge, "partner")]).then(function(e) {
      var t = k(e, 2), n = t[0], r = t[1];
      return { callbackParams: qn(n), partnerParams: qn(r) };
    });
  }
  function Mn(e, t) {
    if (t === void 0) return d.error(Mt), Promise.reject({ message: Gt });
    var n = ue(e), r = Object.keys(n).map(function(o) {
      return { key: o, value: n[o], type: t };
    });
    return Promise.all([w.filterBy(ge, t), w.addBulk(ge, r, !0)]).then(function(o) {
      var i = k(o, 2), a = i[0], u = i[1], c = on(a.map(function(s) {
        return s.key;
      }), u.map(function(s) {
        return s[0];
      }));
      return d.log("Following ".concat(t, " parameters have been saved: ").concat(r.map(function(s) {
        return "".concat(s.key, ":").concat(s.value);
      }).join(", "))), c.length && d.log("Keys: ".concat(c.join(", "), " already existed so their values have been updated")), u;
    });
  }
  function Fn(e, t) {
    return t === void 0 ? (d.error(Mt), Promise.reject({ message: Gt })) : w.deleteItem(ge, [e, t]).then(function(n) {
      return d.log("".concat(e, " ").concat(t, " parameter has been deleted")), n;
    });
  }
  function Wn(e) {
    return e === void 0 ? (d.error(Mt), Promise.reject({ message: Gt })) : w.deleteBulk(ge, e).then(function(t) {
      return d.log("All ".concat(e, " parameters have been deleted")), t;
    });
  }
  var Vn, Ft, G, it = !1, pe = document;
  function Fr() {
    return G = function() {
      var e = document;
      if (e.hidden !== void 0) return { hidden: "hidden", visibilityChange: "visibilitychange" };
      for (var t = x({ mozHidden: "mozvisibilitychange", msHidden: "msvisibilitychange", oHidden: "ovisibilitychange", webkitHidden: "webkitvisibilitychange" }), n = 0; n < t.length; n += 1) {
        var r = k(t[n], 2), o = r[0], i = r[1];
        if (e[o] !== void 0) return { hidden: o, visibilityChange: i };
      }
      return null;
    }(), it ? Promise.reject({ interrupted: !0, message: "Session watch already initiated" }) : (it = !0, ae("session:finished", Hr), G && Xe(pe, G.visibilityChange, Hn), G && pe[G.hidden] ? (d.log("Session request attempt canceled because the tab is still hidden"), Promise.resolve({})) : (h.initParams(), zn()));
  }
  function Wr() {
    return Wt(), h.updateSessionOffset(), h.toBackground(), me();
  }
  function Vr() {
    return w.getFirst(ke).then(function(e) {
      var t = h.current, n = t.lastActive || 0;
      if (Un() && n < e.lastActive) {
        var r = !t.installed && e.installed, o = (t.sessionCount || 0) < (e.sessionCount || 0);
        (r || o) && H("sdk:installed"), h.current = e, jt();
      }
      return e;
    }).then(function() {
      h.updateSessionLength(), h.toForeground();
    }).then(zn);
  }
  function Hn() {
    clearTimeout(Ft);
    var e = G && pe[G.hidden] ? Wr : Vr;
    Ft = setTimeout(e, 0);
  }
  function Yn() {
    G && !pe[G.hidden] && (jt(), it || te() !== "on" || (Ze(pe, G.visibilityChange, Yn), or.__internal__.restartAfterAsyncEnable()));
  }
  function Hr(e, t) {
    if (!t || t.status !== "error") return h.updateInstalled(), me().then(function() {
      return H("sdk:installed");
    });
    d.error("Session was not successful, error was returned from the server:", t.response);
  }
  function Wt() {
    clearInterval(Vn);
  }
  function zn() {
    Wt(), Vn = setInterval(function() {
      return h.updateSessionOffset(), me();
    }, _.sessionTimerWindow);
    var e = h.current, t = e.lastInterval, n = e.sessionCount > 0;
    return !n || n && t * ft >= _.sessionWindow ? Gn().then(function(r) {
      var o, i, a;
      rt({ url: "/session", method: "POST", params: (o = r, i = o.callbackParams, a = o.partnerParams, { callbackParams: i.length ? ue(i) : null, partnerParams: a.length ? ue(a) : null }) }, { auto: !0 });
    }) : (H("attribution:check"), me());
  }
  var Jn = Kt({ url: "/attribution", strategy: "short", continueCb: function(e, t, n) {
    return !e || e && e.status === "error" ? (t(), Promise.resolve({ state: "unknown" })) : e.ask_in ? n(e.ask_in) : (t(), function(r) {
      if (ee(r) || !function(i) {
        var a = i.adid, u = a === void 0 ? "" : a, c = i.attribution, s = c === void 0 ? {} : c;
        return !!u && !!on(Vt, Object.keys(s)).length;
      }(r) || function(i) {
        var a = i.adid, u = i.attribution, c = h.current.attribution || {}, s = u && Vt.some(function(l) {
          return c[l] !== u[l];
        });
        return !s && a === c.adid;
      }(r)) return Promise.resolve({ state: "same" });
      var o = x(r.attribution).filter(function(i) {
        var a = k(i, 1)[0];
        return Vt.indexOf(a) !== -1;
      }).reduce(R, { adid: r.adid });
      return h.current = m(m({}, h.current), {}, { attribution: o }), me().then(function() {
        return H("attribution:change", o), H(tn, o), d.info("Attribution has been updated"), { state: "changed" };
      });
    }(e));
  } }), Vt = ["tracker_token", "tracker_name", "network", "campaign", "adgroup", "creative", "click_label", "state"], Qn = Kt({ url: "/gdpr_forget_device", method: "POST", strategy: "short" }), Ht = { running: "Adjust SDK is running pending GDPR Forget Me request", pending: "Adjust SDK will run GDPR Forget Me request after initialisation", paused: "Adjust SDK is already prepared to send GDPR Forget Me request", off: "Adjust SDK is already disabled" };
  function Xn(e) {
    var t = te();
    return e || t === "on" ? _.isInitialised() ? (Qn.send({ params: m({}, h.getParams()) }).then(function() {
      H("sdk:gdpr-forget-me");
    }), !0) : (d.log(Ht.pending), !0) : (d.log(Ht[t]), !1);
  }
  function Yr() {
    return Bn({ reason: W.REASON_GDPR, pending: !1 }, "finish");
  }
  var at = [];
  function Zn(e, t) {
    at.push({ method: e, description: t, timestamp: Date.now() });
  }
  var ut = "eventDeduplication";
  function zr(e, t) {
    var n, r, o = t.callbackParams, i = t.partnerParams, a = {}, u = m({ eventToken: e.eventToken, deduplicationId: e.deduplicationId }, (n = e.revenue, r = e.currency, isNaN(n) || (n = parseFloat(n)) < 0 || !r ? {} : { revenue: n.toFixed(5), currency: r })), c = m(m({}, ue(o)), ue(e.callbackParams)), s = m(m({}, ue(i)), ue(e.partnerParams));
    return ee(c) || (a.callbackParams = c), ee(s) || (a.partnerParams = s), m(m({}, u), a);
  }
  function Jr(e) {
    return e ? w.getAll(ut).then(function(t) {
      return t.map(function(n) {
        return n.id;
      });
    }).then(function(t) {
      return t.indexOf(e) === -1 ? function(n) {
        var r = _.getCustomConfig().eventDeduplicationListLimit, o = r > 0 ? r : 10;
        return w.count(ut).then(function(i) {
          var a = Promise.resolve();
          if (i >= o) {
            var u = i - o + 1;
            d.log("Event deduplication list limit has been reached. Oldest ids are about to be removed (".concat(u, " of them)")), a = w.trimItems(ut, u);
          }
          return a;
        }).then(function() {
          return d.info("New event deduplication id is added to the list: ".concat(n)), w.addItem(ut, { id: n });
        });
      }(e) : Promise.reject({ message: "Event won't be tracked, since it was previously tracked with the same deduplication id ".concat(e) });
    }) : Promise.resolve();
  }
  function Qr(e) {
    return { clickTime: Ee(), source: "web_referrer", referrer: decodeURIComponent(e) };
  }
  function $n(e, t) {
    var n;
    (n = e || window.location.search.substring(1).split("&").map(function(r) {
      return r.split("=");
    }).reduce(R, {}).adjust_referrer) && rt({ url: "/sdk_click", method: "POST", params: Qr(n) }, { timestamp: t });
  }
  var Xr = ["logLevel", "logOutput"], we = null, st = !1, Te = !1, ct = !1, er = null;
  function tr(e) {
    U("third-party sharing", function() {
      return h.waitForWebUUID().then(function() {
        return function(t) {
          t && t.isEnabled !== void 0 ? rt({ url: "/third_party_sharing", method: "POST", params: { sharing: t.isEnabled ? "enable" : "disable", granularThirdPartySharingOptions: t.granularOptions, partnerSharingSettings: t.partnerSharingSettings } }) : d.error("Can not track third-party sharing without parameters");
        }(e);
      });
    }, { schedule: !1, optionalInit: !0 });
  }
  function Zr() {
    var e;
    te() === "paused" && (Yr(), Promise.all([(e = { uuid: "unknown" }, h.current = e, w.clear(ke).then(function() {
      return w.addItem(ke, e);
    })), w.clear(ge), w.clear(Se)]).then(nr));
  }
  function Be() {
    return st || _.isInitialised();
  }
  function Yt() {
    st = !1, Te = !1, at = [], Ln.clear(), B.running = !1, B.timestamp = null, B.pause = null, it = !1, h.toBackground(), Wt(), G && (clearTimeout(Ft), Ze(pe, G.visibilityChange, Hn), Xe(pe, G.visibilityChange, Yn)), Jn.clear();
  }
  function Ue(e) {
    e && d.log("Adjust SDK has been shutdown due to asynchronous disable"), Yt(), It.forEach(clearTimeout), It = [], de = {}, h.destroy(), Ze(window, "online", En), Ze(window, "offline", jn), w.destroy(), _.destroy();
  }
  function nr() {
    ct = !1, Ue(), Qn.clear(), we = null, d.log("Adjust SDK instance has been destroyed");
  }
  function $r(e) {
    d.log("Adjust SDK is starting with web_uuid set to ".concat(e.uuid));
    var t = h.current.installed;
    te() === "paused" && (d.log(Ht.running), Xn(!0));
    var n = te(), r = function(o) {
      return "Adjust SDK start has been interrupted ".concat(o);
    };
    return n === "off" ? (Ue(), Promise.reject({ interrupted: !0, message: r("due to complete async disable") })) : n === "paused" ? (Yt(), Promise.reject({ interrupted: !0, message: r("due to partial async disable") })) : Te ? Promise.reject({ interrupted: !0, message: r("due to multiple synchronous start attempt") }) : (ot({ cleanUp: !0 }), Fr().then(function() {
      st = !1, Te = !0, t && rr();
    }));
  }
  function rr() {
    var e;
    ct = !0, at.forEach(function(t) {
      typeof t.method == "function" && (d.log("Delayed ".concat(t.description, " task is running now")), t.method(t.timestamp));
    }), at = [], (e = er) && x(de).some(function(t) {
      var n = k(t, 2)[1];
      return n.some(function(r, o) {
        r.id === e && n.splice(o, 1);
      });
    });
  }
  function eo(e) {
    if (e.interrupted) d.log(e.message);
    else if (Ue(), d.error("Adjust SDK start has been canceled due to an error", e), e.stack) throw e;
  }
  function zt(e) {
    te() !== "off" ? (_.set(e), Xe(window, "online", En), Xe(window, "offline", jn), er = ae("sdk:installed", rr), ae("sdk:shutdown", function() {
      return Ue(!0);
    }), ae("sdk:gdpr-forget-me", Zr), ae("attribution:check", function(t, n) {
      return r = n, o = h.current, (i = (r || {}).ask_in) || !o.attribution && o.installed ? (Jn.send({ params: m({ initiatedBy: r ? "backend" : "sdk" }, h.getParams()), wait: i }), h.updateSessionOffset(), me()) : Promise.resolve(o);
      var r, o, i;
    }), typeof e.attributionCallback == "function" && ae("attribution:change", e.attributionCallback), (tt ? Promise.reject({ interrupted: !0, message: "Adjust SDK start already in progress" }) : (tt = !0, w.getFirst(ke).then(Kr).then(function(t) {
      if (t.exists) return tt = !1, t.stored;
      var n, r = ee(h.current) ? { uuid: (n = Date.now(), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(o) {
        var i = (n + 16 * Math.random()) % 16 | 0;
        return n = Math.floor(n / 16), (o === "x" ? i : 11 & i).toString(16);
      })) } : h.current;
      return w.addItem(ke, r).then(function() {
        return h.init(r), jt(), tt = !1, r;
      });
    }).then(function(t) {
      return H(en, t ? t.uuid : "gdpr_forgotten"), t;
    }))).then($r).then($n).catch(eo)) : d.log("Adjust SDK is disabled, can not start the sdk");
  }
  function U(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.schedule, o = n.waitForInitFinished, i = n.optionalInit;
    if (w.getType() !== ve.NO_STORAGE) if (te() === "on") if (i || Be() || !o) {
      if (typeof t == "function") {
        if (!r || ct && Te || !i && !Be()) return t();
        Zn(t, e), d.log("Running ".concat(e, " is delayed until Adjust SDK is up"));
      }
    } else d.error("Adjust SDK can not ".concat(e, ", sdk instance is not initialized"));
    else d.log("Adjust SDK is disabled, can not ".concat(e));
    else d.log("Adjust SDK can not ".concat(e, ", no storage available"));
  }
  var to = { initSdk: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.logLevel, n = e.logOutput, r = vr(e, Xr);
    d.setLogLevel(t, n), Be() ? d.error("You already initiated your instance") : _.hasMissing(r) || (st = !0, w.init(r.namespace).then(function(o) {
      o.type !== ve.NO_STORAGE ? (d.info("Available storage is ".concat(o.type)), we = m({}, r), zt(r)) : d.error("Adjust SDK can not start, there is no storage available");
    }));
  }, getAttribution: function() {
    return U("get attribution", function() {
      return h.getAttribution();
    });
  }, getWebUUID: function() {
    return U("get web_uuid", function() {
      return h.getWebUUID();
    });
  }, waitForAttribution: function() {
    return U("get attribution", function() {
      return h.waitForAttribution();
    }, { schedule: !1 });
  }, waitForWebUUID: function() {
    return U("get web_uuid", function() {
      return h.waitForWebUUID();
    }, { schedule: !1 });
  }, setReferrer: function(e) {
    e && typeof e == "string" ? U("setting reftag", function(t) {
      return $n(e, t);
    }, { schedule: !0, waitForInitFinished: !0, optionalInit: !0 }) : d.error("You must provide a string referrer");
  }, trackEvent: function(e) {
    return function(t) {
      if (w.getType() === ve.NO_STORAGE) {
        var n = "Adjust SDK can not track event, no storage available";
        return d.log(n), Promise.reject(n);
      }
      if (te() !== "on") {
        var r = "Adjust SDK is disabled, can not track event";
        return d.log(r), Promise.reject(r);
      }
      if (!Be()) {
        var o = "Adjust SDK can not track event, sdk instance is not initialized";
        return d.error(o), Promise.reject(o);
      }
      return new Promise(function(i) {
        var a = function(u) {
          return i(function(c, s) {
            if (!c || c && (ee(c) || !c.eventToken)) {
              var l = "You must provide event token in order to track event";
              return d.error(l), Promise.reject(l);
            }
            return Jr(c.deduplicationId).then(Gn).then(function(g) {
              return rt({ url: "/event", method: "POST", params: zr(c, g) }, { timestamp: s });
            }).catch(function(g) {
              return g && g.message && d.error(g.message), Promise.reject(g);
            });
          }(t, u));
        };
        !ct || !Te && Be() ? (Zn(a, "track event"), d.log("Running track event is delayed until Adjust SDK is up")) : a();
      });
    }(e);
  }, addGlobalCallbackParameters: function(e) {
    U("add global callback parameters", function() {
      return Mn(e, "callback");
    });
  }, addGlobalPartnerParameters: function(e) {
    U("add global partner parameters", function() {
      return Mn(e, "partner");
    });
  }, removeGlobalCallbackParameter: function(e) {
    U("remove global callback parameter", function() {
      return Fn(e, "callback");
    });
  }, removeGlobalPartnerParameter: function(e) {
    U("remove global partner parameter", function() {
      return Fn(e, "partner");
    });
  }, clearGlobalCallbackParameters: function() {
    U("remove all global callback parameters", function() {
      return Wn("callback");
    });
  }, clearGlobalPartnerParameters: function() {
    U("remove all global partner parameters", function() {
      return Wn("partner");
    });
  }, switchToOfflineMode: function() {
    U("set offline mode", function() {
      return Kn(!0);
    });
  }, switchBackToOnlineMode: function() {
    U("set online mode", function() {
      return Kn(!1);
    });
  }, stop: function() {
    qt() && _.isInitialised() && Ue();
  }, restart: function() {
    var e;
    ((e = (Et() || {}).reason) === W.REASON_GDPR ? (d.log("Adjust SDK is disabled due to GDPR-Forget-Me request and it can not be re-enabled"), 0) : e ? (d.log("Adjust SDK has been enabled"), On(null), 1) : (d.log("Adjust SDK is already enabled"), 0)) && we && zt(we);
  }, gdprForgetMe: function() {
    var e = Xn();
    e && (e = qt(W.REASON_GDPR, !0)) && _.isInitialised() && Yt();
  }, disableThirdPartySharing: function() {
    tr({ isEnabled: !1 });
  }, trackThirdPartySharing: tr, ThirdPartySharing: function() {
    return Re(function e(t) {
      Ae(this, e), y(this, "_granularOptions", {}), y(this, "_partnerSharingSettings", {}), typeof t != "boolean" && d.warn("isEnabled should be boolean, converting ".concat(t, " results ").concat(!!t)), this._isEnabled = !!t;
    }, [{ key: "isEnabled", get: function() {
      return this._isEnabled;
    } }, { key: "granularOptions", get: function() {
      return this._granularOptions;
    } }, { key: "partnerSharingSettings", get: function() {
      return this._partnerSharingSettings;
    } }, { key: "addGranularOption", value: function(e, t, n) {
      if (e && t && n !== void 0) {
        var r = y({}, t, n);
        this.granularOptions[e] ? this.granularOptions[e] = m(m({}, this.granularOptions[e]), r) : this.granularOptions[e] = r;
      } else d.error("Cannot add granular option, partnerName, key and value are mandatory");
    } }, { key: "addPartnerSharingSetting", value: function(e, t, n) {
      if (e && t && n !== void 0) {
        var r = y({}, t, n);
        this.partnerSharingSettings[e] ? this.partnerSharingSettings[e] = m(m({}, this.partnerSharingSettings[e]), r) : this.partnerSharingSettings[e] = r;
      } else d.error("Cannot add partner sharing setting, partnerName, key and value are mandatory");
    } }]);
  }(), initSmartBanner: function() {
    d.error("function `initSmartBanner` is deprecated");
  }, showSmartBanner: function() {
    d.error("function `showSmartBanner` is deprecated");
  }, hideSmartBanner: function() {
    d.error("function `hideSmartBanner` is deprecated");
  }, __testonly__: { destroy: nr, clearDatabase: function() {
    return w.deleteDatabase();
  } }, __internal__: { restartAfterAsyncEnable: function() {
    d.log("Adjust SDK has been restarted due to asynchronous enable"), we && zt(we);
  } } };
  const or = to;
  return $ = $.default;
})();
const pr = no(ro.exports = gr()), fr = "webUUID";
function oo({ token: I, environment: $ = "production", callback: F = null } = {}) {
  if (!I) throw new Error('Adjust init failed: "token" is required.');
  if (pr.initSdk({ appToken: I, environment: $, logLevel: "verbose" }), typeof F != "function") return mr();
  mr(F);
}
function mr(I = null) {
  const $ = localStorage.getItem(fr);
  if ($) return I ? void I($) : Promise.resolve($);
  const F = pr.waitForWebUUID().then((re) => {
    if (localStorage.setItem(fr, re), !I) return re;
    I(re);
  }).catch((re) => {
    if (console.error("Failed to fetch webUUID from Adjust:", re), !I) return null;
    I(null);
  });
  return I ? void 0 : F;
}
export {
  oo as adjustInit,
  mr as fetchWebUUID
};
